import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export enum TaskListAction {
  RESOLVE_UNSOLICITED_LAB = "RESOLVE_UNSOLICITED_LAB",
}

export interface TaskListAvailableActionsResponse {
  availableActions: TaskListAvailableAction[];
}

export interface TaskListAvailableAction {
  action: TaskListAction;
  allowed: boolean;
  notAllowedReason: string | null;
  notAllowedDebugMessage: string | null;
}

export type TaskListAvailableActionsData = {
  [key in TaskListAction]?: TaskListAvailableAction;
};

export const useTaskListAvailableActions = () => {
  return useApi<TaskListAvailableActionsResponse, TaskListAvailableActionsData>(
    {
      queryOptions: {
        queryFn: async () => {
          const response =
            await axiosInstance.get<TaskListAvailableActionsResponse>(
              "/clinic/task-list/available-actions",
            );

          return response.data;
        },
        select: (data) => {
          return data.availableActions.reduce((acc, action) => {
            acc[action.action] = action;
            return acc;
          }, {} as TaskListAvailableActionsData);
        },
        queryKey: QueryKeys.Provider.TASK_LIST_AVAILABLE_ACTIONS,
      },
    },
  );
};
